module.exports = __webpack_public_path__ + "img/Flussfamilie.76c5acc2.jpg";